import { BigSymbolFreegamesCommonConfiguration } from "../../../api";
import { BigSymbolFreegamesBonus } from "./BigSymbolFreegames";
//import { BigSymbolFreegamesConfig } from "./BigSymbolFreegamesConfig";
import { BigSymbolFreegamesBonusParams } from "./BigSymbolFreegamesParams";

export interface IBigSymbolFreegamesBonusFactory
{
	CreateSpinAndHoldBonus(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegamesBonus;
}

export class BigSymbolFreegamesBonusFactory implements IBigSymbolFreegamesBonusFactory
{
	public CreateSpinAndHoldBonus(gameName: string, params: BigSymbolFreegamesBonusParams, config: BigSymbolFreegamesCommonConfiguration): BigSymbolFreegamesBonus
	{
		return new BigSymbolFreegamesBonus(gameName, params, config);
	}
}